export const NOTIFICATION_TOAST_INIT_TITLE = 'INIT'
